import styled, { keyframes, css } from "styled-components";

const animationProps = "2s ease-in-out 0s normal infinite none running";

/**
 * The leftmost position of the sparkle (the center of the sparkle) in percentage
 */
const ShineLeftPosition = 20;
/**
 * The rightmost position of the sparkle (the center of the sparkle) in percentage
 */
const ShineRightPosition = 80;

const BorderShineHeight = 2;
const BorderShineWidth = 30;
function borderShineKeyframes(rtl?: boolean) {
    const startPos = (rtl ? ShineRightPosition : ShineLeftPosition) - (BorderShineWidth / 2);
    const endPos = (rtl ? ShineLeftPosition : ShineRightPosition) - (BorderShineWidth / 2);
    return keyframes`
        0% {
            opacity: 0;
            left: ${startPos}%;
        }
        20%, 30% {
            opacity: 0.5;
            left: ${startPos}%;
        }
        50%, 60% {
            opacity: 1;
            left: ${endPos}%;
        }
        80% {
            opacity: 0;
            left: ${endPos}%;
        }
        100% {
            opacity: 0;
            left: ${startPos}%;
        }
    `;
}
export const JackpotWidgetBorderShine = styled.div<{bottom?: boolean}>`
    position: absolute;
    width: ${BorderShineWidth}%;
    ${({bottom}) => bottom ? css`
        bottom: ${-(BorderShineHeight / 2)}px;
    ` : css`
        top: ${-(BorderShineHeight / 2)}px;
    `}
    height: ${BorderShineHeight}px;
    z-index: 10;
    background-color: transparent;
    background-image: linear-gradient(90deg, #00000000 0%, #FFFFFF 50%, #00000000 100%);

    animation: ${({bottom}) => borderShineKeyframes(bottom)} ${animationProps};
`;

const RadialShineHeight = 22;
const RadialShineWidth = 20;
function radialShineKeyframes(rtl?: boolean) {
    const startPos = (rtl ? ShineRightPosition : ShineLeftPosition) - (RadialShineWidth / 2);
    const endPos = (rtl ? ShineLeftPosition : ShineRightPosition) - (RadialShineWidth / 2);
    return keyframes`
        0% {
            opacity: 0;
            left: ${startPos}%;
        }
        20%, 30% {
            opacity: 0.1;
            left: ${startPos}%;
        }
        50%, 60% {
            opacity: 1;
            left: ${endPos}%;
        }
        80% {
            opacity: 0;
            left: ${endPos}%;
        }
        100% {
            opacity: 0;
            left: ${startPos}%;
        }
    `;
}
export const JackpotWidgetRadialShine = styled.div<{bottom?: boolean}>`
    position: absolute;
    width: ${RadialShineWidth}%;
    ${({bottom}) => bottom ? css`
        bottom: ${-(RadialShineHeight / 2)}px;
    ` : css`
        top: ${-(RadialShineHeight / 2)}px;
    `}
    height: ${RadialShineHeight}px;
    z-index: 10;
    background-color: transparent;
    background-image: radial-gradient(closest-side at 50% 50%, #FFFFFF 0%, #FFFFFF61 35%, #00000000 100%);

    animation: ${({bottom}) => radialShineKeyframes(bottom)} ${animationProps};
`;
